import React from 'react';
import styles from './css/WhatsIncluded.styl';
import sharedStyles from '../../css/Shared.styl';
import Item from './Item';
import {
  CalculatorIcon,
  CandleIcon,
  ChecklistIcon,
  TreeIcon,
  GravestoneIcon,
  DocumentIcon,
} from './Svgs';

const WhatsIncluded = () => {
  return (
    <div className={sharedStyles.Wrap}>
      <div className={styles.WhatsIncludedBlock}>
        <h2 className={styles.Title}>The guide will help you:</h2>
        <div className={styles.Items}>
          <Item
            icon={<CandleIcon />}
            title="Choose a type of ceremony"
            blurb="Do you want a traditional service or a unique memorial&nbsp;event?"
          />
          <Item
            icon={<GravestoneIcon />}
            title="Decide how to be laid to&nbsp;rest"
            blurb="Burial and cremation are the most common, but there are other&nbsp;options."
          />
          <Item
            icon={<TreeIcon />}
            title="Ensure your legacy"
            blurb="How do you want the world to remember you? Who will deliver your&nbsp;eulogy?"
          />
          <Item
            icon={<CalculatorIcon />}
            title="Know your&nbsp;financial options"
            blurb="Pros and cons of options like life insurance, burial insurance, and funeral&nbsp;pre-payment."
          />
          <Item
            icon={<DocumentIcon />}
            title="Secure essential&nbsp;documents"
            blurb="Learn which documents and information to share with family ahead of&nbsp;time."
          />
          <Item
            icon={<ChecklistIcon />}
            title="Outline your&nbsp;preferences"
            blurb="Use the checklists to stay organized as you begin to&nbsp;plan."
          />
        </div>
      </div>
    </div>
  );
};

export default WhatsIncluded;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/WhatsIncluded/index.js